"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokensToJSON = exports.TokensFromJSONTyped = exports.TokensFromJSON = void 0;
var runtime_1 = require("../runtime");
function TokensFromJSON(json) {
    return TokensFromJSONTyped(json, false);
}
exports.TokensFromJSON = TokensFromJSON;
function TokensFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'masterToken': !(0, runtime_1.exists)(json, 'masterToken') ? undefined : json['masterToken'],
        'sessionToken': json['sessionToken'],
    };
}
exports.TokensFromJSONTyped = TokensFromJSONTyped;
function TokensToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'masterToken': value.masterToken,
        'sessionToken': value.sessionToken,
    };
}
exports.TokensToJSON = TokensToJSON;
//# sourceMappingURL=Tokens.js.map